const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

export interface TokenResponse {
  access_token: string
  token_type: string
  expires_in: number
}

export interface MeResponse {
  id: string
  username: string
  email: string
  role: string
  is_active: boolean
}

export async function login(username: string, password: string): Promise<TokenResponse> {
  const res = await fetch(`${BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { detail?: string }).detail ?? 'Login failed')
  }
  return res.json()
}

export async function getMe(token: string): Promise<MeResponse> {
  const res = await fetch(`${BASE}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Unauthorized')
  return res.json()
}
